// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NItM2sNLMU42eSFaWwL3 {
  background-color: var(--purple);
}

.Qp5xkmMJGKUSGJdCNCHD {
  position: relative;
  z-index: 2;
  background-color: var(--header-background);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
}

.reGHnPvdRhgDCP_ymDgG {
  background: var(--header-background);
  height: 5rem;
  max-width: var(--content-column);
  margin: 0 auto;
  padding: 0.875rem var(--content-padding);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hTYEyjK7VKL0Np8DWqbm,
.bux7wM9r15aZwySkLKwt,
.FZBPUOeRfCBQB_80OoQ7,
.MSboACrHAseqEQSw1LGA {
  display: flex;
  align-items: center;
}

.MSboACrHAseqEQSw1LGA {
  grid-gap: 0.9375rem;
  gap: 0.9375rem;
}

.FZBPUOeRfCBQB_80OoQ7 {
  margin-right: 3rem;
}

.tFi3ysD54ocQgzeX7CcI {
  flex-direction: column;
  position: relative;
}

.HV5tRXum396DVdK9Jfuv {
  margin-right: 1.5rem;
}

.KmtwbG6Xt2tkeuPKmGfL {
  width: 12.5rem;
  margin-top: 0.125rem;
}

.go_raU04_5KnTZiMwMKD {
  align-items: center;
  border: none;
  outline: none;
  background-color: transparent;
  margin-right: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.nEUdpge03T27uQ1RS5el {
  opacity: 0.4;
}

.SPRzWOGh7DZK3fb3nXc_ {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.Rz8ABfrmrzPzdZeDpvJw {
  opacity: 0;
  height: 0;
  width: 0;
  transition: opacity 0.3s ease;
}

.IuYM2aU1EcezshwCE4ec {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 1.5rem 0 4rem
}

.IuYM2aU1EcezshwCE4ec:hover p {
      -webkit-text-decoration-line: underline;
              text-decoration-line: underline;
    }

.M3O1YT1mZu28Wkfd5Rtu {
  margin-right: 0.5rem;
  color: var(--header-text-color);
}

.r8vr6ov2jgD_JcfazPDs {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  height: 100%;
  background-color: #fff;
}

.G8Z9m16Tz6k8p9e4u3EO {
  margin-left: 1.5rem;
}

.jwodBeVwMcWhRoBciJ95 {
  color: var(--secondary-link-color);
}

.wB59jgQBkIBLXGJMmY3o {
  color: var(--header-text-color);
}

.nlyTpj9Va75G9vF_MKjY {
  color: var(--header-text-color);
}

.TytMfbW8J2oNtqz_YzBy {
  color: var(--header-category-highlight-color);
}

.lglaNuIJF6EzltCdfbcP {
  color: var(--secondary-link-color);
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .reGHnPvdRhgDCP_ymDgG {
    padding: 0.75rem var(--content-padding-desktop-small);
  }
}

@media only screen and (min-width: 1023px) and (max-width: 1300px) {
  .wB59jgQBkIBLXGJMmY3o {
    font-size: 0.875rem;
  }

  .IuYM2aU1EcezshwCE4ec {
    margin-left: 1.5rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .reGHnPvdRhgDCP_ymDgG {
    padding: 0.75rem var(--content-padding-tablet);
  }

  .lglaNuIJF6EzltCdfbcP {
    color: var(--secondary-link-color);
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  .KmtwbG6Xt2tkeuPKmGfL {
    width: 10.625rem;
  }

  .r8vr6ov2jgD_JcfazPDs {
    background-color: var(--grey-100);
  }

  .IuYM2aU1EcezshwCE4ec {
    margin-left: 3rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .r8vr6ov2jgD_JcfazPDs {
    background-color: var(--grey-100);
  }

  .lglaNuIJF6EzltCdfbcP {
    color: var(--secondary-link-color);
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  .reGHnPvdRhgDCP_ymDgG {
    padding: 0.75rem var(--content-padding-mobile);
  }

  .KmtwbG6Xt2tkeuPKmGfL {
    width: 10.625rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,8CAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,wCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAS;EAAT,cAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAkB;AACpB;;AAEA;EACE,cAAY;EACZ,oBAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,oBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf;AAOF;;AAJI;MACE,uCAA+B;cAA/B,+BAA+B;IACjC;;AAIJ;EACE,oBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EACE;IACE,qDAAkD;EACpD;AACF;;AAEA;EACE;IACE,mBAAe;EACjB;;EAEA;IACE,mBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,8CAA2C;EAC7C;;EAEA;IACE,kCAAkC;IAClC,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,gBAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;IAClC,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,8CAA2C;EAC7C;;EAEA;IACE,gBAAY;EACd;AACF","sourcesContent":[".rootContainer {\n  background-color: var(--purple);\n}\n\n.header {\n  position: relative;\n  z-index: 2;\n  background-color: var(--header-background);\n  box-shadow: 0 4px 12px var(--black-012);\n}\n\n.headerContent {\n  background: var(--header-background);\n  height: 80px;\n  max-width: var(--content-column);\n  margin: 0 auto;\n  padding: 14px var(--content-padding);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.leftSide,\n.rightSide,\n.rightNavLinks,\n.rightNavIcons {\n  display: flex;\n  align-items: center;\n}\n\n.rightNavIcons {\n  gap: 15px;\n}\n\n.rightNavLinks {\n  margin-right: 48px;\n}\n\n.basketLink {\n  flex-direction: column;\n  position: relative;\n}\n\n.businessPageLink {\n  margin-right: 24px;\n}\n\n.logo {\n  width: 200px;\n  margin-top: 2px;\n}\n\n.menuDropdownBtn {\n  align-items: center;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  margin-right: 24px;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.disabled {\n  opacity: 0.4;\n}\n\n.menuDropdownIconVisible {\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.menuDropdownIconInvisible {\n  opacity: 0;\n  height: 0;\n  width: 0;\n  transition: opacity 0.3s ease;\n}\n\n.menuDropdownLinkBtn {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 24px 0 64px;\n\n  &:hover {\n    & p {\n      text-decoration-line: underline;\n    }\n  }\n}\n\n.giftCardDropdownBtnTitle {\n  margin-right: 8px;\n  color: var(--header-text-color);\n}\n\n.headerMenuWrapper {\n  display: flex;\n  flex-direction: column;\n  overflow-x: auto;\n  height: 100%;\n  background-color: #fff;\n}\n\n.choiceGiftcardLink {\n  margin-left: 24px;\n}\n\n.textClassName {\n  color: var(--secondary-link-color);\n}\n\n.text {\n  color: var(--header-text-color);\n}\n\n.rightNavLinksText {\n  color: var(--header-text-color);\n}\n\n.activeNavItem {\n  color: var(--header-category-highlight-color);\n}\n\n.iconsLabels {\n  color: var(--secondary-link-color);\n}\n\n@media (--desktop-small) {\n  .headerContent {\n    padding: 12px var(--content-padding-desktop-small);\n  }\n}\n\n@media only screen and (min-width: 1023px) and (max-width: 1300px) {\n  .text {\n    font-size: 14px;\n  }\n\n  .menuDropdownLinkBtn {\n    margin-left: 24px;\n  }\n}\n\n@media (--tablet) {\n  .headerContent {\n    padding: 12px var(--content-padding-tablet);\n  }\n\n  .iconsLabels {\n    color: var(--secondary-link-color);\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .logo {\n    width: 170px;\n  }\n\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n\n  .menuDropdownLinkBtn {\n    margin-left: 48px;\n  }\n}\n\n@media (--mobile) {\n  .headerMenuWrapper {\n    background-color: var(--grey-100);\n  }\n\n  .iconsLabels {\n    color: var(--secondary-link-color);\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .headerContent {\n    padding: 12px var(--content-padding-mobile);\n  }\n\n  .logo {\n    width: 170px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootContainer": `NItM2sNLMU42eSFaWwL3`,
	"header": `Qp5xkmMJGKUSGJdCNCHD`,
	"headerContent": `reGHnPvdRhgDCP_ymDgG`,
	"leftSide": `hTYEyjK7VKL0Np8DWqbm`,
	"rightSide": `bux7wM9r15aZwySkLKwt`,
	"rightNavLinks": `FZBPUOeRfCBQB_80OoQ7`,
	"rightNavIcons": `MSboACrHAseqEQSw1LGA`,
	"basketLink": `tFi3ysD54ocQgzeX7CcI`,
	"businessPageLink": `HV5tRXum396DVdK9Jfuv`,
	"logo": `KmtwbG6Xt2tkeuPKmGfL`,
	"menuDropdownBtn": `go_raU04_5KnTZiMwMKD`,
	"disabled": `nEUdpge03T27uQ1RS5el`,
	"menuDropdownIconVisible": `SPRzWOGh7DZK3fb3nXc_`,
	"menuDropdownIconInvisible": `Rz8ABfrmrzPzdZeDpvJw`,
	"menuDropdownLinkBtn": `IuYM2aU1EcezshwCE4ec`,
	"giftCardDropdownBtnTitle": `M3O1YT1mZu28Wkfd5Rtu`,
	"headerMenuWrapper": `r8vr6ov2jgD_JcfazPDs`,
	"choiceGiftcardLink": `G8Z9m16Tz6k8p9e4u3EO`,
	"textClassName": `jwodBeVwMcWhRoBciJ95`,
	"text": `wB59jgQBkIBLXGJMmY3o`,
	"rightNavLinksText": `nlyTpj9Va75G9vF_MKjY`,
	"activeNavItem": `TytMfbW8J2oNtqz_YzBy`,
	"iconsLabels": `lglaNuIJF6EzltCdfbcP`
};
export default ___CSS_LOADER_EXPORT___;
